import type { StackProps } from '@mui/material';
import { CustomizedAccordion, Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledHeader,
  StyledHeading,
  StyledAccentBar,
  StyledContentStack,
  StyledTextStack,
  DescriptionText,
  MainText,
  StyledAccordionStack,
} from './styles';
import { AccordionData, whatWeDoData } from './whatWeDoData';

export const WhatWeDo = ({ ...props }: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <StyledHeader>
          <StyledHeading variant="h2">What do we do?</StyledHeading>
          <StyledAccentBar />
        </StyledHeader>
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">{whatWeDoData.mainText}</MainText>
            <DescriptionText variant="strong_400">
              {whatWeDoData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion data={AccordionData()} />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
